var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    viewBox: "0 0 76 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.794922 72.0007H45.4958L51.929 56.709H0.794922V72.0007Z",
    fill: "#0099FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.732422 53.6581L55.8934 46.0674L62.6458 29.6738L0.732422 38.293V53.6581Z",
    fill: "#0099FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.732422 35.2847L67.7162 18.279L75.2666 0L0.732422 19.4176V35.2847Z",
    fill: "#0099FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.350396476d196a83ab46ab11d6b75096.svg";
export { ForwardRef as ReactComponent };